import { renderMetaTags, useQuerySubscription } from "react-datocms"
import { connect } from "react-redux"
import Head from "next/head"
import { useRouter } from "next/router"
import SupplierSignupEnquiry from "../components/supplierSignup/SupplierSignupEnquiry/SupplierSignupEnquiry"
import worksLeaders from "../images/pages/home/worksLeaders.svg"
import worksMarketing from "../images/pages/home/worksMarketing.svg"
import worksStorefront from "../images/pages/home/worksStorefront.svg"
import { getSubscription, queries } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

const howSupplierWorks = {
  title: "How HOPP Works",
  features: [
    {
      image: worksStorefront,
      title: "Set up your digital storefront",
      text: "Put yourself in front of a wide B2C and B”B audience through your personalised HOPP profile then sit back and wait for the enquiries to come through",
    },
    {
      image: worksMarketing,
      title: "Be featured on our mareting channels",
      text: "Digitally promote your business and connect with prospective clients through our organic and paid promotions",
    },
    {
      image: worksLeaders,
      title: "Align your business with top industry leaders",
      text: "Enjoy being part of our collective of the most established in the premiun events sector and create industry connections through exclusive networking events",
    },
  ],
}

const BecomeSupplierPage = ({ subscription, options, query, userAttributes, isAuthenticated }) => {
  const {
    data: { seo, signup },
  } = useQuerySubscription(subscription)

  const router = useRouter()

  if (isAuthenticated && userAttributes["custom:status"]) {
    setTimeout(() => {
      router.push("/supplier-signup")
    }, 1000)
    return null
  } else {
    return (
      <Layout options={options}>
        <Seo global={seo} title="Supplier Signup" />
        <SupplierSignupEnquiry data={signup} referralId={query?.ref} howSupplierWorks={howSupplierWorks} />
      </Layout>
    )
  }
}

export async function getServerSideProps({ query }) {
  const graphqlRequest = {
    query: `
      {
        ${queries.seo}
        ${queries.signup}
      }
    `,
  }

  const subscription = await getSubscription(graphqlRequest)

  const options = await loadOptionsData()

  return {
    props: {
      subscription,
      options,
      query,
    },
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    userAttributes: state.auth.userAttributes,
  }
}

export default connect(mapStateToProps)(BecomeSupplierPage)
